var l = (o, r, e) => new Promise((s, t) => {
  var i = (n) => {
    try {
      u(e.next(n));
    } catch (c) {
      t(c);
    }
  }, a = (n) => {
    try {
      u(e.throw(n));
    } catch (c) {
      t(c);
    }
  }, u = (n) => n.done ? s(n.value) : Promise.resolve(n.value).then(i, a);
  u((e = e.apply(o, r)).next());
});
function m(o) {
  if (o == null) return null;
  const r = Array.isArray(o) ? o : o.split(",");
  return new Set(r.map((e) => e.trim()).filter(Boolean));
}
const p = "core";
function _(o, r) {
  return r === null || o === p ? !0 : r.has(o);
}
function h(o) {
  var e;
  const { teacherTotter: r } = o.providers;
  if (r != null && r.enabled && !r.syncUrl)
    throw new Error("[analytics] teacher-totter is enabled but no syncUrl was provided.");
  return {
    app: o.app,
    environment: o.environment,
    providers: o.providers,
    enabledGroups: m(o.enabledFeatureGroups),
    events: o.events,
    debug: (e = o.debug) != null ? e : !1
  };
}
class f {
  constructor(r, e) {
    this.config = r, this.providers = e, this.commonProps = {
      mx_app: r.app,
      mx_env: r.environment,
      mx_locale: "",
      mx_country_code: "",
      mx_user_profile_id: "",
      mx_user_profile_type: "unknown",
      mx_market_region_id: "",
      mx_school_id: "",
      mx_one_roster_user_id: ""
    }, this.runProviders((s) => s.init());
  }
  setCommonProps(r) {
    this.commonProps = {
      mx_app: this.config.app,
      mx_env: this.config.environment,
      mx_locale: r.locale,
      mx_country_code: r.countryCode,
      mx_user_profile_id: r.userProfileId,
      mx_user_profile_type: r.userProfileType,
      mx_market_region_id: r.marketRegionId,
      mx_school_id: r.schoolId,
      mx_one_roster_user_id: r.oneRosterUserId
    }, this.runProviders((e) => e.setCommonProps(this.commonProps));
  }
  identify() {
    const r = this.commonProps.mx_user_profile_id;
    this.runProviders((e) => e.identify(r, this.commonProps));
  }
  track(r, e) {
    return l(this, null, function* () {
      const s = this.config.events[r];
      if (!s) {
        this.config.debug && console.warn(`[analytics] Unknown event "${r}" not in the event map; skipping.`);
        return;
      }
      const t = {
        name: r,
        group: s.group,
        props: e,
        commonProps: this.commonProps
      };
      yield Promise.all(
        this.providers.map((i) => l(this, null, function* () {
          if (!(i.isGroupGated && !_(t.group, this.config.enabledGroups)))
            try {
              yield i.track(t);
            } catch (a) {
              this.warn(a);
            }
        }))
      );
    });
  }
  trackSession(r) {
    this.runProviders((e) => {
      var s;
      return (s = e.trackSession) == null ? void 0 : s.call(e, r);
    });
  }
  shutdown() {
    this.runProviders((r) => r.shutdown());
  }
  // Analytics must never break a consuming app, so provider failures are isolated and suppressed.
  runProviders(r) {
    this.providers.forEach((e) => {
      try {
        r(e);
      } catch (s) {
        this.warn(s);
      }
    });
  }
  warn(r) {
    this.config.debug && console.warn("[analytics] provider error (suppressed):", r);
  }
}
export {
  f as A,
  _ as i,
  m as p,
  h as r
};



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/mx-teacher-analytics/dist/analytics-client-CsxFmTXW.js
// module id = Xgm8
// module chunks = 0